import React, { useState } from 'react';
import { Slider } from '@material-ui/core';

const RangeSlider = (props) => {
  const {
    value,
    onChange,
    OnChangeCommitted,
    step,
    min,
    max,
    unitOfMeasurement,
  } = props;

  let unit = unitOfMeasurement ?? '';

  return (
    <div className="range-slider__wrapper">
      <div className="range-slider__header">
        <span>
          {min} {unit}
        </span>
        <span>
          {max} {unit}
        </span>
      </div>
      <Slider
        value={value}
        min={min}
        max={max}
        valueLabelDisplay="auto"
        onChange={onChange}
        onChangeCommitted={OnChangeCommitted}
        step={step}
      />
    </div>
  );
};

export default RangeSlider;
